import React, { Component } from 'react';
import {setAndGetAttributes} from './FormInputFunctions';
import Wrp from "../../hoc/Wrp/Wrp";

class Number extends Component {

  fieldOnChangeHandler(e){
    const {changeHandler} = this.props;
    let input_value = e.target.value.replace(/[^0-9]/g, ''); 
    if((//input_value.search(/^[0]{1,}[\d]/)!==-1 || // takes care of leading zeroes
      input_value.search(/^(\d+)?[-]?([\d]{1,9})?([\%])?$/)===-1) &&  //main pattern
      input_value!==''){
      e.target.value  = (this.input_prev_value!==undefined)?this.input_prev_value:'';
      changeHandler(e.target.value);
    }else {  
        e.target.value = (input_value!==undefined)?input_value:'';
        this.input_prev_value = e.target.value;
        changeHandler(e.target.value);
    }
    // changeHandler(e.target.value);
  } 

  preventNonNumericalInput(e) {
    if(this.props.isAllowNegative===false){
      e = e || window.event;
      let charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
      let charStr = String.fromCharCode(charCode);
  
      if (!charStr.match(/^[0-9]+$/))
        e.preventDefault();
    }
  }

  render() {
    const {value} = this.props;
    let attr = setAndGetAttributes(this.props);
    
    return (
      <Wrp>
        <input 
          type="text"
          {...attr}
          onChange={e=>this.fieldOnChangeHandler(e)}
          value={value}
          min={this.props.min}
          // pattern="[0-9]*"
          onKeyPress={e=>this.preventNonNumericalInput(e)}
          max={this.props.max}
          maxlength={this.props.max}
        />
      </Wrp>        
    );
  }
}

Number.defaultProps = {
  isMandatory:false,
  className: 'form-control',
  min:'',
  isAllowNegative:true,
  max:9
}

export default Number;